// This was a list given that show priority of insurance we want to
// show in the footer. The list will change based on what's available in
// a given state.

export const INSURANCE_PRIORITY_LIST = [
  'Cigna',
  'Aetna',
  'United Health Care',
  'Unity Preferred Network',
  'ClaimDOC',
  'VNPN',
  // 'Cash Pay',
  'OccuNet',
  'Prime Health',
  'Centivo',
  'Anthem',
  'Kaiser Permanente',
  'TriWest',
  'Bright Health Plan',
  'Friday Health Plan',
  'Select Health',
  'Lucent',
  'CareSource',
  'Blue Cross Blue Shield',
  'Medicare',
  'Ascension',
  'Humana',
  'Molina',
  'Moda',
  'Devoted',
  'CareFirst',
];
